import { useMemo } from 'react';
import { ICatalogState } from 'src/contexts/Catalog/store/types';
import { IPage } from '../types/CatalogType';

export const useCurrentPagesSkus = (
  currentPagesData: ICatalogState['exhibition']['currentPagesData'],
) =>
  useMemo(
    () =>
      currentPagesData.reduce(
        (acc: IPage['skus'], cur: IPage) => [...acc, ...cur.skus],
        [],
      ),
    [currentPagesData],
  );
